"use strict";
checkList.classy.controller({
    name: 'IncomeChangeController',
    inject: ['$scope', 'RestService', 'ApplicationService', 'PutService', 'AlertService', 'ResetService', 'BinFactory'],
    init: function() {
        this.$.incomeChange2Open = false;
        this.$.ApplicationService = this.ApplicationService;
        this.$.setAnswer(81);
        this.$.ResetService = this.ResetService;
        // Set a default if option is undefined (per parent)
        for (let i = 1; i <= this.ApplicationService.getFamilyData().data.length; i++) {
            if (!angular.isDefined(this.$.answer["incomeChangeParent" + i])) {
                this.$.answer["incomeChangeParent" + i] = "none";
            }
        }
    },
    jobChange: function(parentNumber)
    {
        var section = this.$.section[parentNumber];
        var choice = this.$.answer[section][parentNumber].choice;
        var amount = this.$.answer[section][parentNumber].amount[choice];
        var calcAmount = amount;
        if (choice == 1)
            calcAmount = amount * 12;
        this.ApplicationService.getFamilyData().edit_sums["Inc_Annual_" + parentNumber] = calcAmount;
    },
    payChange: function(parentNumber, increase)
    {
        var section = this.$.section[parentNumber];
        var choice = this.$.answer[section][parentNumber].choice;
        var amount = this.$.answer[section][parentNumber].amount[choice];
        var self = this;
        var calculateDiff = function(parentNumber)
        {
            var newDiff = 0;
            var origAmount = self.ApplicationService.getFamilyData().edit_sums["Inc_Annual_" + parentNumber];
            if (choice == 1)
                newDiff = Math.round(parseInt(origAmount) * parseFloat(amount/100));
            else if (choice == 2)
                newDiff = parseInt(amount);

            return newDiff;
        }
        if (choice == 3)
            this.ApplicationService.getFamilyData().edit_sums["Inc_Annual_" + parentNumber] = amount;
        else
        {
            if (increase)
                this.ApplicationService.getFamilyData().edit_sums["Inc_Annual_" + parentNumber] =
                    parseInt(this.ApplicationService.getFamilyData().edit_sums["Inc_Annual_" + parentNumber]) + parseInt(calculateDiff(parentNumber));
            else
                this.ApplicationService.getFamilyData().edit_sums["Inc_Annual_" + parentNumber] -= parseInt(calculateDiff(parentNumber));
        }
    },
    incomeChangeFinish: function()
    {
        var caseNo = 'case81';
        for (var i = 1; i <= this.ApplicationService.getFamilyData().data.length; i++)
        {
            if (this.$.section[i] == "job_loss"
                || this.$.section[i] == "job_change" || this.$.section[i] == "became_disabled")
                this.jobChange(i);
            else if (this.$.section[i] == "decrease_in_pay")
                this.payChange(i, false);
            else if (this.$.section[i] == "increase_in_pay")
                this.payChange(i, true);

            var section = this.$.section[i];
            if (section != "none")
            {
                var choice = this.$.answer[section][i].choice;
                for (var j = 1; j < 4; j++) {
                    if (choice != j)
                        delete this.$.answer[section][i].amount[j];
                }
            }
        }

        var queue = [];
        queue.push(this.PutService.putEditSums());
        this.$.alertPut(queue, caseNo, 0, this.$.answer);
        this.$.setIncomeChange2Open(false)
    },
    incomeChangeNext: function()
    {
        var noneCount = 0;
        this.$.error = false;
        this.$.section = [];
        for (var i = 1; i <= this.ApplicationService.getFamilyData().data.length; i++)
        {
            this.$.section[i] = this.$.answer['incomeChangeParent' + i];
            if (typeof this.$.answer['incomeChangeParent' + i] == 'undefined')
                this.$.error = true;
            else
            {
                if (this.$.answer['incomeChangeParent' + i] == "none")
                    noneCount++;

                if (this.$.answer[this.$.section[i]] == undefined) {
                    this.$.answer[this.$.section[i]] = [];
                    this.$.answer[this.$.section[i]][1] = {};
                    this.$.answer[this.$.section[i]][2] = {};
                    this.$.answer[this.$.section[i]][1].amount = [];
                    this.$.answer[this.$.section[i]][2].amount = [];
                }
            }
        }
        if (noneCount == this.ApplicationService.getFamilyData().data.length)
            this.$.incomeChangeFinish();
        else if (this.$.error == false)
            this.$.incomeChange2Open = true;
        else 
            this.$.incomeChangeFinish();

    },
    setIncomeChange2Open: function(bool)
    {
        this.$.incomeChange2Open = bool;
    }
});
